module.exports = __webpack_public_path__ + "static/media/dispatchLogo.e58eb4b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dispatchLogo.svg
// module id = 2434
// module chunks = 0